import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
/*
 * @Descripttion: 
 * @version: 
 * @Author: 王凯
 * @LastEditors: 王凯
 */
import Vue from "vue";
import pagination from "./Pagination";
import inputs from "./YkFormComponet/ykInputs";
import header from "./Header/index";
import form from "./YkFormComponet/ykForm";
import selects from "./YkFormComponet/ykSelects";
import formItem from "./YkFormComponet/ykFormItem";
import date from "./YkFormComponet/ykDate";
import footer from "./YkFormComponet/ykFooter";
import menu from "./YkFormComponet/ykMenu";
import swithTag from "./YkFormComponet/ykSwithTag";
import upload from "./YkFormComponet/ykUpload";
import copy from "./YkFormComponet/ykCopy.vue";
var components = {
  pagination: pagination,
  inputs: inputs,
  header: header,
  form: form,
  selects: selects,
  formItem: formItem,
  date: date,
  menu: menu,
  footer: footer,
  swithTag: swithTag,
  upload: upload,
  copy: copy
};
Vue.use({
  install: function install(Vue) {
    Object.keys(components).forEach(function (key) {
      Vue.component("yk-".concat(key), components[key]);
    });
  }
});